import { Check, X } from "lucide-react";
import type { LockPrecondition } from "./blueprintTypes";

interface Props {
  preconditions: LockPrecondition[];
}

export function LockPreconditionsList({ preconditions }: Props) {
  return (
    <ul className="space-y-1">
      {preconditions.map((p) => (
        <li key={p.key} className="flex items-start gap-2 text-xs">
          {p.met ? (
            <Check size={14} className="mt-0.5 shrink-0 text-emerald-600 dark:text-emerald-400" />
          ) : (
            <X size={14} className="mt-0.5 shrink-0 text-rose-600 dark:text-rose-400" />
          )}
          <span className={p.met ? "text-text-muted" : "text-text-primary"}>
            {p.label}
            {p.detail && <span className="text-text-faint"> — {p.detail}</span>}
          </span>
        </li>
      ))}
    </ul>
  );
}
